<template>
  <div id="app" class="">
    <transition name="fade" mode="out-in">
      <router-view ></router-view>
    </transition>
  </div>
</template>

<script>
import theHeader from './components/common/TheHeader'
import theFooter from './components/common/TheFooter'
import { mapActions } from 'vuex'
export default {
  name: 'app',
  data () {
    return {
    }
  },
  computed: {
  },
  beforeMount () {
    this.setCalculatorState(this).then(response => {
      document.title = response.data.data.empresa + ' - Calculadora Contábil'
    }).catch(err => {
      console.log(err)
    })
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    ...mapActions([
      'setCalculatorState'
    ])
  },
  components: {
    theHeader,
    theFooter
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
$primary: #609DE6;
$highlight: #FFD500;
$primary-invert: findColorInvert($primary);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
.b-table .table th {
  padding: 0;
  margin-bottom: 0.5em;
  font-weight: 400;
  padding-bottom: 0.5rem;
}

@import "./scss/main.scss";
</style>
